import { useMutation } from "@tanstack/react-query";
import { Eye } from "lucide-react";
import { useTranslation } from "react-i18next";

import { useAuth } from "@/app/auth/context";
import { Button } from "@/components/ui/Button";
import { stopViewAs } from "@/lib/auth-api";
import { reloadAt } from "@/lib/reload";

/** Shown while an administrator sees the interface as another user: whose view it is, and the way back. */
export function ViewAsBanner() {
  const { t } = useTranslation();
  const { me } = useAuth();
  const stop = useMutation({
    mutationFn: stopViewAs,
    // Reload: menus, permissions and cached data all belong to the other user until then.
    onSuccess: () => reloadAt("/admin/users"),
  });
  if (!me?.viewing_as) return null;
  return (
    <div
      role="status"
      className="flex flex-wrap items-center justify-center gap-x-4 gap-y-2 border-b border-accent/40 bg-accent-soft px-4 py-2 text-sm text-accent-ink"
    >
      <Eye className="size-4 shrink-0" aria-hidden="true" />
      <span>{t("viewAs.banner", { name: me.user.display_name, username: me.user.username })}</span>
      <Button variant="secondary" onClick={() => stop.mutate()} busy={stop.isPending}>
        {t("viewAs.stop")}
      </Button>
    </div>
  );
}
